"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var DynamicScrollToTop = function (props) {
    react_1.useEffect(function () {
        if (props.history.action === 'POP') {
            return;
        }
        var hash = props.location.hash;
        if (hash) {
            var element = document.querySelector(hash);
            if (element) {
                element.scrollIntoView({ block: 'start', behavior: 'smooth' });
            }
        }
        else {
            window.scrollTo(0, 0);
        }
    }, [props.history.action, props.location]);
    return react_1.default.createElement("div", null);
};
exports.default = react_router_dom_1.withRouter(DynamicScrollToTop);
//# sourceMappingURL=DynamicScrollToTop.js.map